import type { HelpFile } from '../../types/help'
import { OrganizationStepTestIds } from '../../../testids/OrganizationStepTestIds'

export const organizationStepHelp: HelpFile = {
  docPage: '/docs/onboarding/organization-step',
  texts: {
    [OrganizationStepTestIds.cardTitleManager]: 'Wählen Sie die Vorgesetzten-Identität für die zu onboardende Person. Die Auswahl durchsucht aktive Workforce-Identitäten; die gewählte Person wird zum Ziel der MANAGED_BY-Beziehung.',
    [OrganizationStepTestIds.cardTitleOrganizationAttributes]: 'Organisationsspezifische Attribute wie offizieller Name, Land oder Kostenstelle.',
    [OrganizationStepTestIds.cardTitleRelationships]: 'Beziehungen dieser Organisation zu anderen Parteien — etwa Mutter- oder Schwestergesellschaften.',
  },
}
